import { useLocation, useNavigate } from 'react-router-dom';

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: any) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (<div className='card mb-5 mb-xl-10'>
    <div className='card-body pb-0 pt-0'>
      {props.recurrence !== true && <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold'>
        <li className='nav-item mt-2'>
          <span
            className={
              `nav-link text-active-primary ms-0 me-10 py-5 cursor-pointer ` +
              (location.pathname === '/compras/locacao-de-quadra' && 'active')
            }
            onClick={() => navigate('/compras/locacao-de-quadra')}
          >
            Locação de quadras
          </span>
        </li>
        {/* <li className='nav-item mt-2'>
          <span
            className={
              `nav-link text-active-primary ms-0 me-10 py-5 cursor-pointer ` +
              (location.pathname === '/assinaturas/aulas-mensal' && 'active')
            }
            onClick={() => navigate('/compras/aula-avulso')}
          >
            Aula avulso
          </span>
        </li> */}
        <li className='nav-item mt-2'>
          <span
            className={
              `nav-link text-active-primary ms-0 me-10 py-5 cursor-pointer ` +
              (location.pathname === '/compras/day-use' && 'active')
            }
            onClick={() => navigate('/compras/day-use')}
          >
            Day use
          </span>
        </li>
        <li className='nav-item mt-2'>
          <span
            className={
              `nav-link text-active-primary ms-0 me-10 py-5 cursor-pointer ` +
              (location.pathname === '/compras/pacotes-de-creditos' && 'active')
            }
            onClick={() => navigate('/compras/pacotes-de-creditos')}
          >
            Pacotes de crédito
          </span>
        </li>
        <li className='nav-item mt-2'>
          <span
            className={
              `nav-link text-active-primary ms-0 me-10 py-5 cursor-pointer ` +
              (location.pathname === '/compras/creditos' && 'active')
            }
            onClick={() => navigate('/compras/creditos')}
          >
            Créditos
          </span>
        </li>
      </ul>}

      {props.recurrence === true && <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold'>
        <li className='nav-item mt-2'>
          <span
            className={
              `nav-link text-active-primary ms-0 me-10 py-5 cursor-pointer ` +
              (location.pathname === '/assinaturas/clubinho' && 'active')
            }
            onClick={() => navigate('/assinaturas/clubinho')}
          >
            Clubinho
          </span>
        </li>
        <li className='nav-item mt-2'>
          <span
            className={
              `nav-link text-active-primary ms-0 me-10 py-5 cursor-pointer ` +
              (location.pathname === '/assinaturas/locacao-de-quadra' && 'active')
            }
            onClick={() => navigate('/assinaturas/locacao-de-quadra')}
          >
            Locação de quadras
          </span>
        </li>
        <li className='nav-item mt-2'>
          <span
            className={
              `nav-link text-active-primary ms-0 me-10 py-5 cursor-pointer ` +
              (location.pathname === '/assinaturas/aulas-mensal' && 'active')
            }
            onClick={() => navigate('/assinaturas/aulas-mensal')}
          >
            Aulas mensal
          </span>
        </li>
      </ul>}
    </div>
  </div>);
}